import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import { redirectToSecureKey } from "../../redux/SecureKey/secureKeyActions";
import { Modal } from "../Modal/modal";
import { SKInteracEng, SKInteracFr } from "../Icons/icons";
import secureKeyInteracEng from "../../media/icons/SKInteracEng_white.png";
import secureKeyInteracFr from "../../media/icons/SKInteracFR_white.png";
import "./RedirectModal.css";
import PropTypes from "prop-types";

const RedirectModal = ({
  isModalOpen,
  setIsModalOpen,
  isCheckMyStatus,
  country,
  language,
  redirectToSecureKey,
  id,
}) => {
  const [secureKeyNetworkError, setSecureKeyNetworkError] = useState(false);

  const handleWhileLoadingSecureKeyUrl = () => {
    return setIsModalOpen(false);
  };

  const handleErrorsWhenLoadingSecureKeyUrl = () => {
    setSecureKeyNetworkError(true);
    return setIsModalOpen(true);
  };

  const onAccept = () => {
    const currentUrl = window.location.protocol + "//" + window.location.host;

    redirectToSecureKey(
      {
        country,
        callbackRouteName: isCheckMyStatus ? "cmsCallback" : "callback",
        currentSiteUrl:
          currentUrl === process.env.REACT_APP_AUDI_QC_PRIVACY_PORTAL
            ? process.env.REACT_APP_AUDI_QC_PRIVACY_PORTAL
            : process.env.REACT_APP_VW_QC_PRIVACY_PORTAL,
        language: language === "FRA" ? "French" : "English",
      },
      handleWhileLoadingSecureKeyUrl,
      handleErrorsWhenLoadingSecureKeyUrl
    );
  };

  const onCancel = () => {
    setIsModalOpen(false);
  };

  const getModalFooter = () => {
    return (
      <div className="modal-footer-btns">
        <div id="cancel-button sg-component-variant">
          <button
            className="c-btn c-btn--secondary"
            onClick={() => onCancel()}
            data-testid="cancel-btn"
          >
            <span className="c-btn__text">{i18n.t(rk.BUTTON.CANCEL)}</span>
          </button>
        </div>
        <div id="accept-button" className="securekey-btn-container">
          <button
            className="c-btn c-btn--icon securekey-btn"
            data-testid="accept-btn"
            onClick={() => onAccept()}
          >
            <div className="securekey-btn-text">
              <span className="c-btn__text">
                {" "}
                {i18n.t(rk.BUTTON.CONTINUE_WITH)}{" "}
              </span>
            </div>
            <i
              className="c-btn__icon c-icon securekey-btn-image"
              aria-hidden="true"
              role="img"
            >
              <img
                src={
                  language === "FRA" ? secureKeyInteracFr : secureKeyInteracEng
                }
                alt="errorIcon"
              />
            </i>
          </button>
        </div>
      </div>
    );
  };

  const getModalSecureKeyNetworkError = () => {
    return (
      <section
        id="js-notifications-group"
        className="c-notifications-group js-panelgroup u-m-none"
      >
        <div className="c-notification__container  js-notification-container">
          <div className="c-notification  c-notification--error">
            <div className="c-notification__outer-wrap">
              <div className="c-notification__inner-wrap">
                <i
                  className="c-notification__status-icon u-text-white"
                  aria-hidden="true"
                  role="img"
                ></i>

                <div className="c-notification__content">
                  <p className="c-notification__title u-text-white">
                    {i18n.t(rk.SECURE_KEY.NETWORK_ERROR_TITLE)}
                  </p>

                  <p className="c-notification__text c-status-message u-text-white">
                    {i18n.t(rk.SECURE_KEY.NETWORK_ERROR_DESCRIPTION)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderSKModalTitle = () => {
    return language === "ENG" ? <SKInteracEng /> : <SKInteracFr />;
  };

  return (
    <div className="securekey-modal">
      <Modal
        modalTitle={renderSKModalTitle()}
        bodyContent={
          secureKeyNetworkError
            ? getModalSecureKeyNetworkError()
            : i18n.t(rk.SECURE_KEY.DESCRIPTION)
        }
        closeModal={() => {
          setIsModalOpen(false);
          setSecureKeyNetworkError(false);
        }}
        footerContent={secureKeyNetworkError ? <></> : getModalFooter()}
        isModalOpen={isModalOpen}
        id={id}
      />
    </div>
  );
};

RedirectModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  isCheckMyStatus: PropTypes.bool,
  country: PropTypes.string,
  language: PropTypes.string,
  redirectToSecureKey: PropTypes.func.isRequired,
  id: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    country: state.initialReducer.country,
    language: state.initialReducer.language,
  };
};

const mapDispatchToProps = (dispatch) => ({
  redirectToSecureKey: (
    payload,
    handleWhileLoadingSecureKeyUrl,
    handleErrorsWhenLoadingSecureKeyUrl
  ) =>
    dispatch(
      redirectToSecureKey(
        payload,
        handleWhileLoadingSecureKeyUrl,
        handleErrorsWhenLoadingSecureKeyUrl
      )
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RedirectModal));
